export const markdown = {
  'with-markdown-content': {
    h1: {
      fontSize: ['xx-large', 'xxx-large'],
      fontWeight: 'bold',
    },
    h2: {
      fontSize: ['x-large', 'xx-large'],
      fontWeight: 'semibold',
    },
    h3: {
      fontSize: ['large', 'x-large'],
      fontWeight: 'semibold',
    },
    h4: {
      fontSize: ['med', 'large'],
      fontWeight: 'semibold',
    },
    h5: {
      fontSize: ['sm', 'med'],
      fontWeight: 'semibold',
    },
    h6: {
      fontSize: ['sm', 'sm'],
      fontWeight: 'semibold',
    },
    ul: {
      listStyle: 'inside',
    },
    ol: {
      listStyle: 'inside',
      listStyleType: 'decimal',
    },
    blockquote: {
      margin: 0,
      padding: "0 1em",
      color: "#57606a",
      borderLeft: "4px solid",
      borderColor: "brand.500",
    },
    a: {
      color: "brand.500",
      textDecoration: "underline",
      transition: "0.2s color ease",
      _hover: {
        color: "brand.900",
      }
    },
    p: {
      margin: '14px 0'
    },
  }
}
